import React from "react";

const EMOJIS = [
  "😀", "😂", "🤣", "😊", "😍", "😘", "🥰", "😎",
  "🤔", "😅", "😭", "😢", "😡", "🥳", "😴", "🙃",
  "👍", "👎", "👏", "🙏", "💪", "🔥", "💯", "❤️",
  "🎉", "✨", "⚡", "💡", "📈", "📉", "💰", "🚀",
];

/**
 * Compact horizontal emoji bar. Clicking an emoji calls onPick(emoji).
 * Designed to sit above a chat composer for quick reactions/inserts.
 */
export default function EmojiPickerBar({ onPick, testId = "emoji-picker-bar" }) {
  return (
    <div
      data-testid={testId}
      className="flex gap-1 overflow-x-auto whitespace-nowrap py-1 px-1 bg-slate-50 rounded-lg w-full min-w-0 max-w-full"
      style={{ WebkitOverflowScrolling: "touch" }}
    >
      {EMOJIS.map((e) => (
        <button
          key={e}
          type="button"
          onClick={() => onPick(e)}
          data-testid={`${testId}-${e}`}
          className="text-lg w-8 h-8 grid place-items-center rounded-md hover:bg-slate-200 shrink-0"
          style={{ transition: "background-color 0.15s ease, transform 0.15s ease" }}
          aria-label={`Insert ${e}`}
        >
          {e}
        </button>
      ))}
    </div>
  );
}
